<template>
  <div class="vz-individual-order-cargo-category vz-individual-order-cargo-overlay-wrapper">
    <vz-cargo-category-auto-complete
      v-model="category"
      label="Категория груза"
      cleanable
    />
    <div v-if="isOnlyCorrespondence || disabled" class="vz-individual-order-cargo-overlay" />
  </div>
</template>

<script setup lang="ts">
import VzCargoCategoryAutoComplete from '@/components/autocomplete/vz-cargo-category-auto-complete.vue';
import {useOrderStore} from '@/stores/order';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()

const category = computed({
  get() {
    // Преобрзовываем '' в null, если есть
    return orderStore.orderForm.cargo.category || null
  },
  set (category: string | null) {
    if (category || orderStore.orderForm.cargo.category) {
      orderStore.orderForm.cargo.category = category
      orderStore.getOrderPriceAction()
    }
  }
})

const isOnlyCorrespondence = computed(() => {
  return orderStore.orderForm.cargo.type.correspondence && !orderStore.orderForm.cargo.type.cargo
})
</script>
